import React from 'react';
import { Upload, FileText, X } from 'lucide-react';

interface FileUploadProps {
  selectedFile: File | null;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isProcessing: boolean;
  onRemoveFile: () => void;
}

export default function FileUpload({ selectedFile, onFileChange, isProcessing, onRemoveFile }: FileUploadProps) {
  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-navy-700 dark:text-navy-200 mb-2">
        Arquivo
      </label>
      <div className={`border-2 border-dashed rounded-xl p-8 text-center transition-all duration-200 ${
        selectedFile
          ? 'border-accent-400 bg-accent-400/5 dark:border-accent-400/50 dark:bg-accent-400/10'
          : 'border-navy-300 dark:border-navy-600 hover:border-accent-400 dark:hover:border-accent-400/50'
      }`}>
        {selectedFile ? (
          <div className="space-y-3">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-accent-400/10 dark:bg-accent-400/20 rounded-full">
              <FileText className="h-6 w-6 text-accent-500 dark:text-accent-400" />
            </div>
            <p className="text-sm text-navy-700 dark:text-navy-200 font-medium">
              {selectedFile.name}
            </p>
            <p className="text-xs text-navy-500 dark:text-navy-400">
              {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
            </p>
            <button
              type="button"
              onClick={onRemoveFile}
              className="inline-flex items-center space-x-1 text-sm text-error-500 hover:text-error-600 dark:text-error-400 dark:hover:text-error-300 transition-colors duration-200"
            >
              <X className="h-4 w-4" />
              <span>Remover arquivo</span>
            </button>
          </div>
        ) : (
          <div className="relative">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-navy-100 dark:bg-navy-800 rounded-full mb-4">
              <Upload className="h-7 w-7 text-navy-400 dark:text-navy-500" />
            </div>
            <p className="text-sm text-navy-700 dark:text-navy-200 font-medium">
              Arraste um arquivo ou clique para selecionar
            </p>
            <p className="mt-2 text-xs text-navy-500 dark:text-navy-400">
              PDF, Word ou TXT (máximo 20MB)
            </p>
            <input
              type="file"
              onChange={(e) => {
                if (e.target.files && e.target.files[0]) {
                  const file = e.target.files[0];
                  if (file.size > 20 * 1024 * 1024) {
                    alert('O tamanho máximo do arquivo é 20MB.');
                    e.target.value = '';
                    return;
                  }
                  onFileChange(e);
                }
              }}
              accept=".pdf,.doc,.docx,.txt"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              disabled={isProcessing}
            />
          </div>
        )}
      </div>
    </div>
  );
}
